import React, { useContext, useMemo } from 'react';
import {
	ICreateSubCategoryContext,
	CreateSubCategoryContext,
} from '../../createSubCategoryState/createSubCategoryContext';
import PageBookmarkBtn from 'components/PageBookmarkBtn/PageBookmarkBtn';
import style from './CreateSubCategoryControlPanel.module.scss';

const CreateSubCategoryControlPanel: React.FC = () => {
	const { changeVisibleForm, visibleForm, defaultCustomerLanguage, translations } =
		useContext<ICreateSubCategoryContext>(CreateSubCategoryContext);

	const hasTranslationError = useMemo(() => {
		if (!defaultCustomerLanguage) {
			return false;
		}
		const defaultNameTranslation = translations.find(
			(translation) => translation.languageId === defaultCustomerLanguage.id,
		)?.name;
		return !defaultNameTranslation;
	}, [defaultCustomerLanguage, translations]);

	return (
		<div className={style.container} data-test="CreateSubCategoryControlPanel">
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('mainForm')}
				isActive={visibleForm === 'mainForm'}
				btnName="mainInfoBookmark"
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('translations')}
				isActive={visibleForm === 'translations'}
				btnName="translationsBookmark"
				isError={hasTranslationError}
			/>
		</div>
	);
};

export default CreateSubCategoryControlPanel;
